import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { requestAuth } from '../../http/httpRequest'
import { toastOn } from '../../store/slices/toast'

const AddItemsToListPanel = ({ nameList, setReload }) => {
    const [items, setItems] = useState([])
    const dispatch = useDispatch()

    const getData = async () => {
        try {
            const response = await requestAuth('get', `/nombreEstado/${nameList}/subEstados`, null)
            const opt = response.data.map(item => ({
                id: item.id,
                label: item.nombre,
                status: "existing",
            }))
            setItems(opt)
        } catch (error) {
            dispatch(
                toastOn({
                    type: 'danger',
                    message: error?.response?.data?.message || 'Error al listar las opciones',
                })
            )
        }
    }

    useEffect(() => {
        if (nameList) getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = (index, value) => {
        setItems(prev => {
            const updated = [...prev]
            const current = updated[index]
            updated[index] = {
                ...current,
                label: value,
                status: current.id ? "modified" : "new",
            }
            return updated
        })
    }

    const handleAdd = () => {
        setItems([...items, { id: null, label: "", status: "new" }])
    }

    const handleRemove = async (item, index) => {
        if (!item.id) {
            setItems(prev => prev.filter((_, i) => i !== index))
            return
        }
        try {
            await requestAuth("delete", `/estado/${item.id}`)
            setItems(prev => prev.filter((_, i) => i !== index))
            setReload(x => !x)
            dispatch(toastOn({ type: "success", message: "Item eliminado" }))
        } catch (error) {
            dispatch(toastOn({ type: 'danger', message: (`Error: ${error?.response?.data?.message || 'error desconocido!'}`) }))
        }
    }

    const handleSave = async (item, index) => {
        try {
            if (item.id) {
                // actualizar
                await requestAuth("put", `/estado`, { id: item.id, nombre: item.label, globalEdit: true })
                updateStatus(index, "saved")
                setReload(x => !x)
                dispatch(toastOn({ type: "success", message: "Item actualizado" }))
            } else {
                // crear
                const res = await requestAuth("post", `/estado`, { nombre: item.label, main_estado_nombre: nameList })
                setItems(prev => {
                    const updated = [...prev]
                    updated[index] = { ...updated[index], id: res.data.id, status: "saved" }
                    return updated
                })
                setReload(x => !x)
                dispatch(toastOn({ type: "success", message: "Item creado" }))
            }
        } catch (error) {
            dispatch(toastOn({ type: "danger", message: error?.response?.data?.message || "Error al guardar" }))
        }
    }

    const updateStatus = (index, status) => {
        setItems(prev => {
            const updated = [...prev]
            updated[index] = { ...updated[index], status }
            return updated
        })
    }

    return (
        <div className="space-y-1">
            {items.map((item, idx) => (
                <div key={idx} className="flex gap-1 items-center">
                    <input
                        type="text"
                        value={item.label}
                        onChange={(e) => handleChange(idx, e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && (item.status === "new" || item.status === "modified")) {
                                e.preventDefault();
                                handleSave(item, idx);
                            }
                        }}
                        autoFocus={item.status === "new"}
                        className="border border-gray-300 px-2 py-1.5 rounded-md w-full dark:bg-gray-800 dark:border-gray-500 dark:text-gray-200"
                        placeholder={`Item ${idx + 1}`}
                    />
                    <button
                        type="button"
                        onClick={() => handleSave(item, idx)}
                        disabled={!(item.status === "new" || item.status === "modified")}
                        className={`fa fa-check cursor-pointer px-[11px] py-[11px] rounded-md ${item.status === "new" || item.status === "modified"
                            ? "bg-green-500 dark:bg-green-600 text-white"
                            : "bg-gray-300 text-gray-500 dark:text-gray-400 dark:bg-gray-600 cursor-not-allowed"
                            }`}
                    />
                    <button
                        type="button"
                        onClick={() => handleRemove(item, idx)}
                        disabled={item.status === "saved"}
                        className={`fa fa-close cursor-pointer px-[11px] py-[11px] rounded-md ${item.status === "new"
                            ? "bg-gray-300 text-gray-500 dark:text-gray-400 dark:bg-gray-600 cursor-not-allowed"
                            : "bg-red-500 dark:bg-red-600 text-white"
                            }`}
                    />
                </div>
            ))}

            <button
                type="button"
                onClick={handleAdd}
                className="fa fa-plus bg-blue-500 dark:bg-blue-600 text-white px-2.5 py-[9px] rounded-md"
            >
            </button>
        </div>
    )
}

export default AddItemsToListPanel
